/**
 * The shell renders whatever id map the page gives it.
 *
 * Patient Summary shipped its Design View with `patient-summary-design-*` ids
 * and existing tests address them, so the shell cannot hard-code its own. A page
 * passes the ids it wants and inherits `AD` for anything it leaves out.
 */
import { AD } from "@/constants/testIds";

export function designerTestIds(overrides) {
  return { ...AD, ...(overrides || {}) };
}
